import { Link, Routes, Route } from 'react-router-dom'
import styled from '@emotion/styled'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsConditions from './pages/TermsConditions'

const Navigation = styled.nav`
  padding: 1rem;
  background-color: #f8f9fa;
`

const NavLink = styled(Link)`
  margin-right: 1rem;
  color: #007bff;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`

function App() {
  return (
    <>
      <Navigation>
        <NavLink to="/privacy">Privacy Policy</NavLink>
        <NavLink to="/terms">Terms & Conditions</NavLink>
      </Navigation>
      
      <Container>
        <Routes>
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/" element={<PrivacyPolicy />} />
        </Routes>
      </Container>
    </>
  )
}

export default App 